module.exports = __webpack_public_path__ + "img/ballon.cf5d4800.svg";